import "./index.module-0f44807b.css";
const t = "_reolink_1a1h5_7", e = "_title_1a1h5_1", _ = "_desc_1a1h5_13", c = "_camovue_1a1h5_20", o = "_dark_1a1h5_33", s = {
  "title-with-desc-content": "_title-with-desc-content_1a1h5_1",
  reolink: t,
  title: e,
  desc: _,
  camovue: c,
  dark: o
};
export {
  s
};
//# sourceMappingURL=index.module-98f90ec5.js.map
